import _styled from "@emotion/styled/base";
var FixedNavigation = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1n43dc30"
} : {
  target: "e1n43dc30",
  label: "FixedNavigation"
})(function () {
  return {
    display: 'flex',
    flexFlow: 'column nowrap',
    position: 'fixed',
    top: 0,
    minWidth: '300px',
    maxWidth: '300px',
    height: '100vh',
    backgroundColor: '#F7F7F7'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9kb2N1bWVudGF0aW9uLWxheW91dC9GaXhlZE5hdmlnYXRpb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXdCIiwiZmlsZSI6Ii4uLy4uL3NvdXJjZS9kb2N1bWVudGF0aW9uLWxheW91dC9GaXhlZE5hdmlnYXRpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuY29uc3QgRml4ZWROYXZpZ2F0aW9uID0gc3R5bGVkLmRpdigoKSA9PiAoe1xuICBkaXNwbGF5OiAnZmxleCcsXG4gIGZsZXhGbG93OiAnY29sdW1uIG5vd3JhcCcsXG4gIHBvc2l0aW9uOiAnZml4ZWQnLFxuICB0b3A6IDAsXG4gIG1pbldpZHRoOiAnMzAwcHgnLFxuICBtYXhXaWR0aDogJzMwMHB4JyxcbiAgaGVpZ2h0OiAnMTAwdmgnLFxuICBiYWNrZ3JvdW5kQ29sb3I6ICcjRjdGN0Y3J1xufSkpXG5cbmV4cG9ydCB7IEZpeGVkTmF2aWdhdGlvbiB9XG4iXX0= */");
export { FixedNavigation };
//# sourceMappingURL=FixedNavigation.js.map